import React, { useEffect, useState } from 'react';
import { db } from '../firebase-config';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';

export default function PatientClinicalNotes({ patientId, onSelectClinicalNote }) {
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!patientId) {
            setNotes([]);
            return;
        }

        setLoading(true);
        const notesRef = collection(db, 'patients', patientId, 'notes');
        const q = query(notesRef, orderBy('createdAt', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const list = snapshot.docs
                .map(d => ({ id: d.id, ...d.data() }))
                .filter(n => (n.clinicalNotes || '').trim().length > 0);
            setNotes(list);
            setLoading(false);
        }, (err) => {
            console.error('Error listening to clinical notes:', err);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [patientId]);

    const preview = (text) => {
        if (!text) return '';
        return text.length > 100 ? text.slice(0, 100) + '…' : text;
    };

    if (!patientId) return null;

    return (
        <div className="card">
            <h3 className="section-title">Clinical Notes</h3>
            {loading && <div>Loading clinical notes...</div>}
            {!loading && notes.length === 0 && <div style={{ color: '#666' }}>No clinical notes yet</div>}
            <div style={{ maxHeight: 240, overflowY: 'auto' }}>
                {notes.map(n => (
                    <div key={n.id} onClick={() => onSelectClinicalNote && onSelectClinicalNote(n)} style={{ padding: '0.5em', marginBottom: '0.4em', background: '#fffaf0', borderRadius: 4, cursor: 'pointer' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ fontSize: '0.9em', color: '#333' }}><strong>{new Date((n.createdAt && n.createdAt.seconds ? n.createdAt.seconds * 1000 : Date.now())).toLocaleString()}</strong></div>
                            <div style={{ fontSize: '0.8em', color: '#666' }}>Template: {n.templateName || 'SOAP'}</div>
                        </div>
                        <div style={{ fontSize: '0.95em', color: '#444' }}>{preview(n.clinicalNotes || '')}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
